import { BehaviorSubject, Observable } from 'rxjs';
import { UserModel } from '../Models/Auth/UserModel';
import { UserHelper } from '../Helpers/UserHelper';
import { authService, serviceBundler } from '../App';
import { AxiosResponse } from 'axios';
import { HttpHelper } from '../Helpers/HttpHelper';

export class TourService {
  public TourStart: BehaviorSubject<boolean>;
  public TourHomePageSubject: BehaviorSubject<boolean>;
  public TourLoginPageSubject: BehaviorSubject<boolean>;
  public TourDevicesPageSubject: BehaviorSubject<boolean>;
  public TourSettingsPageSubject: BehaviorSubject<boolean>;
  public TourUserPageSubject: BehaviorSubject<boolean>;

  public tourHomePageActive: boolean = false;
  public tourLoginPageActive: boolean = false;
  public tourDevicesPageActive: boolean = false;
  public tourSettingsPageActive: boolean = false;
  private tourNotificationsPage: boolean = false;
  private tourMachinesPage: boolean = false;
  public tourUsersPage: boolean = false;

  public users!: Array<UserModel>;
  constructor() {
    this.TourStart = new BehaviorSubject<boolean>(false);

    this.TourHomePageSubject = new BehaviorSubject<boolean>(false);
    this.TourLoginPageSubject = new BehaviorSubject<boolean>(false);
    this.TourDevicesPageSubject = new BehaviorSubject<boolean>(false);
    this.TourUserPageSubject = new BehaviorSubject<boolean>(false);
    this.TourSettingsPageSubject = new BehaviorSubject<boolean>(false);
  }

  public StartAllTours() {
    this.StartHomePageTour();
    this.StartLoginPageTour();
    this.StartDevicesPageTour();
    this.StartSettingsPageTour();
  }

  public EndAllTours() {
    this.EndHomePageTour();
    this.EndDevicesPageTour();
    this.EndLoginPageTour();
    this.EndSettingsPageTour();
  }

  // home page tour
  public StartHomePageTour() {
    this.tourHomePageActive = true;
    this.TourHomePageSubject.next(true);
  }

  public EndHomePageTour() {
    this.tourHomePageActive = false;
  }

  // login page tour
  public StartLoginPageTour() {
    this.tourLoginPageActive = true;
    this.TourLoginPageSubject.next(true);
  }

  public EndLoginPageTour() {
    this.tourLoginPageActive = false;
  }

  // devices page tour
  public StartDevicesPageTour() {
    this.tourDevicesPageActive = true;
    this.TourDevicesPageSubject.next(true);
  }

  public EndDevicesPageTour() {
    this.tourDevicesPageActive = false;
  }

  // settings page tour
  public StartSettingsPageTour() {
    this.tourSettingsPageActive = true;
    this.TourSettingsPageSubject.next(true);
  }

  public EndSettingsPageTour() {
    this.tourSettingsPageActive = false;
  }
}
